module.exports = __webpack_public_path__ + "static/across-the-water-540274a70347e2d9730553ed8182e5ed.jpg";